/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Upgrade_DescriptionInputs */

const en_directory_promotion_upgrade_description = /** @type {(inputs: Directory_Promotion_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate the Sponsor plan on Pricing, then return here to submit a sponsored tool.`)
};

const zh_directory_promotion_upgrade_description = /** @type {(inputs: Directory_Promotion_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先在价格页面激活 Sponsor 套餐，再返回这里提交赞助产品。`)
};

/**
* | output |
* | --- |
* | "Activate the Sponsor plan on Pricing, then return here to submit a sponsored tool." |
*
* @param {Directory_Promotion_Upgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_upgrade_description = /** @type {((inputs?: Directory_Promotion_Upgrade_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Upgrade_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_upgrade_description(inputs)
	return zh_directory_promotion_upgrade_description(inputs)
});
export { directory_promotion_upgrade_description as "directory.promotion.upgrade_description" }